<template>
	<div class="white pos-rel rounded-lg min-h-screen">
		<div class="header">
			<div>Invoice Number</div>
		</div>
		<v-btn
			fab
			flat
			class="top-left-align pa-0 ma-0 pt-1"
			@click="closeModal"
		>
			<v-icon>close</v-icon>
		</v-btn>
		<v-container align-center>
			<v-layout justify-center>
				<v-flex>
					<v-layout justify-center row wrap>
						<v-flex>
							<v-autocomplete
								v-model="selectedYear"
								label="Select Year"
								:items="filterYears"
								:autcomplete="false"
								placeholder="Year"
								class="text-field-wrapper pt-4"
								clearable
							/>
						</v-flex>
						<v-flex>
							<v-autocomplete
								v-model="selectedMonth"
								label="Select Month"
								:items="filterMonths"
								:autcomplete="false"
								placeholder="Month"
								class="text-field-wrapper pt-4"
								clearable
							/>
						</v-flex>
					</v-layout>
					<v-layout justify-center>
						<v-btn
							round
							:dark="!!selectedYear && !!selectedMonth"
							:color="themeInputColor"
							:disabled="!selectedYear || !selectedMonth"
							:loading="isInvoiceFetching"
							@click="getAgencyInvoiceNumbers"
						>
							Get Invoice Numbers
						</v-btn>
					</v-layout>
					<v-list
						v-if="Object.keys(invoiceNumberData).length"
						two-line
					>
						<template
							v-for="(item, index) in Object.keys(
								invoiceNumberData
							)"
						>
							<v-list-tile :key="item" avatar ripple>
								<v-list-tile-content>
									<v-list-tile-title>
										{{ camelCaseToWords(item) }}
									</v-list-tile-title>
									<v-list-tile-sub-title
										v-if="item !== 'gst'"
										class="text--primary"
									>
										₹{{ invoiceNumberData[item] }}
									</v-list-tile-sub-title>
									<v-list-tile-sub-title
										v-else
										class="text--primary d-flex"
									>
										<div
											v-for="(gst,
											gstIndex) in Object.keys(
												invoiceNumberData[item]
											)"
											:key="gstIndex"
											class="d-flex"
										>
											<div class="d-flex">
												{{
													`${gst.toUpperCase()}: ₹${
														invoiceNumberData[
															"gst"
														][gst]
													}`
												}}
											</div>
											<v-icon
												@click="
													copyToClipBoard(gst, true)
												"
												>filter_none</v-icon
											>
										</div>
									</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action v-if="item !== 'gst'">
									<v-icon @click="copyToClipBoard(item)"
										>filter_none</v-icon
									>
								</v-list-tile-action>
							</v-list-tile>
							<v-divider :key="index"></v-divider>
						</template>
					</v-list>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
import { mapState } from "vuex";
import ApiService from "@/store/api-service";
import { SHOW_ALERT } from "@/store/action-types";
import { BASE_URL } from "../../../config";
import { MONTHS } from "../constants";

export default {
	props: ["appType", "themeInputColor", "model"],
	data() {
		return {
			selectedMonth: "",
			selectedYear: "",
			isInvoiceFetching: false,
			invoiceNumberData: {}
		};
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		filterYears() {
			return [2021, 2022, 2023, 2024, 2025];
			// const currentYear = new Date().getFullYear();
			// return [currentYear - 1, currentYear];
		},
		filterMonths() {
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentMonth = currentDate.getMonth() + 1;
			return currentYear === this.selectedYear
				? MONTHS.slice(0, currentMonth)
				: MONTHS;
		}
	},
	methods: {
		async getAgencyInvoiceNumbers() {
			this.isInvoiceFetching = true;
			try {
				const payload = {
					access_token: this.ACCESS_TOKEN,
					params: {
						month:
							MONTHS.findIndex(
								month => month === this.selectedMonth
							) + 1,
						year: this.selectedYear
					}
				};
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getRetailerInvoiceDetails`;
				const response = await ApiService.post(endpoint, payload);
				const { response: data, statusCode } = response;
				if (statusCode === 200) {
					this.invoiceNumberData = data;
				}
			} catch (e) {
				this.showAlert(e.message);
			}
			this.isInvoiceFetching = false;
		},
		camelCaseToWords(text) {
			if (text) {
				if (text === "gst") {
					return "GST";
				}
				const splitText = text.replace(/([A-Z])/g, " $1");
				return splitText.charAt(0).toUpperCase() + splitText.slice(1);
			}
			return "";
		},
		copyToClipBoard(item, isGstKey = false) {
			const text = isGstKey
				? this.invoiceNumberData["gst"][item]
				: this.invoiceNumberData[item];
			try {
				let input = document.createElement("input");
				input.setAttribute("value", text);
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Copied successfully!"
				});
			} catch (e) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Error occured while copying"
				});
			}
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		}
	}
};
</script>

<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
}
</style>
